<template>
  <div class="auth_content auth_ai">
    <gc-loading :is-show="loadingShow" />

    <div class="ai_top">
      <span v-wechat-title="$t('auth.home.nameText1')" />
      <authStatus
        text-type="2"
        :readonly="isStatusShow"
        :auth-status="authStatus.is_realname_auth"
      />
      <div class="form_bg">
        <van-form :readonly="isReadonly">
          <div class="form_label">
            <van-field
              v-model="formData.real_name"
              :border="false"
              :name="$t('auth.aiAuth.formText1')"
              :label="$t('auth.aiAuth.formText1')"
              :placeholder="$t('auth.aiAuth.placeholder1')"
              :rules="[{ required: true }]"
              @focus="realNameFocus()"
              @blur="realNameBlur()"
              @input="checkErr('real_name_err')"
            />
            <errorText :text="formData.err_auth_info.real_name_err" />
          </div>
          <cardType
            :readonly="isReadonly"
            :card-type="formData.card_type"
            @getCardType="getCardType"
          />
          <van-field
            v-if="formData.card_type != 1"
            v-model="cardtypeText"
            :is-link="!isReadonly"
            readonly
            :name="$t('auth.aiAuth.formText2')"
            :label="$t('auth.aiAuth.formText2')"
            :placeholder="$t('auth.aiAuth.formText2')"
            @click="cardtypeShowFn()"
          />
          <div class="form_label no_line">
            <van-field
              v-model="formData.id_number"
              :border="false"
              :formatter="formatter"
              :name="$t('auth.aiAuth.formText3')"
              :label="$t('auth.aiAuth.formText3')"
              :placeholder="$t('auth.aiAuth.placeholder3')"
              :rules="[{ required: true }]"
              @focus="idNumberFocus()"
              @blur="idNumberBlur()"
              @input="checkErr('id_number_err')"
            />
            <errorText :text="formData.err_auth_info.id_number_err" />
          </div>
        </van-form>
      </div>
      <ImgTitle
        v-if="!isReadonly"
        alt="上传图片标题"
        :data-type="formData.card_type"
        :card-type="formData.card_pic_type"
        :readonly="!isReadonly"
      >
        <errorText :text="formData.err_auth_info.piccard_err" />
      </ImgTitle>

      <div v-if="formData.card_type === '1'" class="auth_upload">
        <template v-if="!isReadonly">
          <ossUpload
            :readonly="isReadonly"
            :limt-size="1024*5"
            :upload-des="$t(`auth.nameAuth.imgTip1`)"
            :upload-showback="formData.piccard"
            @getUploadData="getPiccard"
          />
          <ossUpload
            v-if="!isReadonly || formData.piccard_reserve!=''"
            :limt-size="1024*5"
            :readonly="isReadonly"
            :upload-des="$t(`auth.nameAuth.imgTip2`)"
            :upload-showback="formData.piccard_reserve"
            @getUploadData="getPiccardReserve"
          />
        </template>

      </div>
      <div v-else class="auth_upload">
        <ossUpload
          :readonly="isReadonly"
          :limt-size="1024*5"
          :upload-des="cardtypeText"
          :upload-showback="formData.piccard"
          @getUploadData="getPiccard"
        />
      </div>
    </div>

    <div class="ai_bottom">
      <!-- <van-button  block type="info" @click="onSubmit()">提交审核</van-button> -->
      <div v-if="!isReadonly" class="pd_16">
        <van-button block type="info" @click="onSubmit()">{{ $t(`auth.nameAuth.btnText1`) }}</van-button>
        <p v-if="formData.card_type === '1'" class="mt_20">{{ $t(`auth.nameAuth.statusTip3`) }} <span class="clr_brown" @click="goAgain('/auth/nameAuth/aiForm')">{{ $t(`auth.nameAuth.statusTip33`) }}</span></p>
      </div>
      <template v-else>
        <div v-if="authStatus.is_realname_auth != 3" class="bottom_status">
          <p class="round_safe">
            <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3882 5.76471C16.6588 5.76471 14.1647 4.82353 12.4235 3.17647C12.1882 2.94118 11.8118 2.94118 11.5765 3.17647C9.88235 4.82353 7.34118 5.76471 4.61176 5.76471C4.28235 5.76471 4 6.04706 4 6.37647V13.8588C4 16.2588 5.27059 18.4706 7.34118 19.8353L11.6706 22.6588C11.7647 22.7059 11.9059 22.7529 12 22.7529C12.0941 22.7529 12.2353 22.7059 12.3294 22.6588L16.6588 19.8353C18.7765 18.4706 20 16.2118 20 13.8588V6.37647C20 6.04706 19.7176 5.76471 19.3882 5.76471ZM13.1294 15.9294C13.1294 16.3529 12.6588 16.8235 12 16.8235C11.2941 16.8235 10.8706 16.3529 10.8706 15.9294C10.8706 15.3176 11.5765 14.8941 11.5765 14C11.5765 12.8706 10.5882 11.3176 10.5882 10.3294C10.5882 9.57647 11.1529 9.05882 12 9.05882C12.8471 9.05882 13.4118 9.57647 13.4118 10.3294C13.4118 11.2706 12.4235 12.8706 12.4235 14C12.4706 14.9882 13.1294 15.2706 13.1294 15.9294Z" fill="#666666" />
            </svg>
          </p>
          {{ $t(`auth.aiAuth.statusTip6`) }}
        </div>
        <div v-else class="pd_16">
          <van-button block type="info" @click="onSubmit()">{{ $t(`auth.nameAuth.btnText1`) }}</van-button>
          <p v-if="formData.card_type === '1'" class="mt_20">{{ $t(`auth.nameAuth.statusTip3`) }} <span class="clr_brown" @click="goAgain('/auth/nameAuth/aiForm')">{{ $t(`auth.nameAuth.statusTip33`) }}</span></p>
        </div>
      </template>

    </div>

    <van-action-sheet
      :show="cardtypeShow"
      :actions="cardtypeInfo"
      :cancel-text="$t(`auth.aiAuth.cancel`)"
      close-on-click-action
      @select="onSelectType"
      @cancel="onCancel"
    />
  </div>
</template>
<script>
import { ajaxHttp } from '@/api/api'
import { Toast, Form, Field, Button, ActionSheet } from 'vant'

import ImgTitle from '../../components/imgTitle/index'
import ossUpload from '@/components/ossUpload'
import cardType from '../../components/cardType/index'
import authStatus from '../../components/authStatus/index'
import errorText from '../../components/errorText/index'

export default {
  name: 'NormalAuth',
  components: {
    ossUpload,
    ImgTitle,
    cardType,
    authStatus,
    errorText,
    vanForm: Form,
    vanField: Field,
    vanActionSheet: ActionSheet,
    vanButton: Button

  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    statusShow: {
      type: Boolean,
      default: false
    },
    authInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loadingShow: false,
      previewShow: false,
      cardtypeShow: false,
      authStatus: { is_realname_auth: 0 }, // 认证状态
      cardtypeInfo: [
        { name: this.$t(`auth.opnAuth.userText5`), val: '1' },
        { name: this.$t(`auth.opnAuth.userText7`), val: '3' },
        { name: this.$t(`auth.opnAuth.userText6`), val: '2' }
      ],
      normal_real_name: '',
      normal_id_number: '',
      formData: {
        card_type: '1',
        real_name: '',
        id_number: '',
        card_pic_type: '1', // 身份证
        piccard: '', // 证件正面
        piccard_reserve: '', // 证件反面
        err_auth_info: {
          id_number_err: '',
          piccard_err: '',
          real_name_err: ''
        } // 报错信息
      },
      pathInfo: {},
      uploadBtn: this.$t(`auth.opnAuth.userText5`)
    }
  },
  computed: {
    isReadonly() {
      return this.readonly
    },
    isStatusShow() {
      return this.statusShow
    },
    cardtypeText() {
      switch (this.formData.card_pic_type) { // 身份类型 大陆 港澳台等，类型数组转具体文案
        case '3':
          return this.$t(`auth.opnAuth.userText7`)
        case '2':
          return this.$t(`auth.opnAuth.userText6`)
        default:
          return this.$t(`auth.opnAuth.userText5`)
      }
    }
  },
  watch: {
    authInfo: {
      handler(newVal, oldVal) {
        if (!newVal) { return false }
        this.authStatus = newVal
      },
      immediate: true
    }
  },
  created() {
    const self = this
    // this.formData.card_type = sessionStorage.getItem('area_id')
    this.$nextTick(() => {
      const { query } = self.$route
      self.pathInfo = query
      self.formData.card_type = query.cardType ? query.cardType : '1'
      self.isStatusShow && self.getAuthData()
    })
  },
  methods: {
    checkErr($type) {
      this.formData.err_auth_info[$type] = ''
    },
    formatter(value) {
      // 过滤输入的中文字符
      return value.replace(/^[\u4e00-\u9fa5]{0,}$/, '')
    },
    getAuthStatus() { // 获取认证状态 认证中，认证失败等
      ajaxHttp.$get('/h5/auth_status').then(res => {
        if (res.code === 1) {
          this.authStatus = res.data.is_realname_auth
        } else { Toast(res.message) }
      })
    },
    realNameFocus() {
      this.formData.real_name = this.normal_real_name
    },
    idNumberFocus() {
      this.formData.id_number = this.normal_id_number
    },
    realNameBlur() {
      this.normal_real_name = this.formData.real_name
      this.formData.real_name = this.formatName(this.formData.real_name)
    },
    idNumberBlur() {
      this.normal_id_number = this.formData.id_number
      this.formData.id_number = this.changeIdCardIncludeStart(this.formData.id_number)
    },
    formatName(str) { // 名字隐藏前几位
      return new Array(str.length).join('*') + str.substr(-1)
    },
    changeIdCardIncludeStart(str) { // 身份证隐藏前后
      return str.substr(0, 1) + new Array(str.length).join('*') + str.substr(-1)
    },
    getAuthData() { // 回显获取认证信息 姓名 身份证等
      const self = this
      this.loadingShow = true
      ajaxHttp.$get('/h5/real_auth_info').then(res => {
        if (res.code === 1) {
          this.formData = res.data
          if (this.isReadonly) { // 只读状态隐藏 姓名和身份证号
            this.normal_real_name = res.data.real_name // 真实
            this.normal_id_number = res.data.id_number // 真实
            this.formData.id_number = this.changeIdCardIncludeStart(res.data.id_number)
            this.formData.real_name = this.formatName(res.data.real_name)
          }
        } else { Toast(res.message) }
        this.$nextTick(() => {
          self.loadingShow = false
        })
      })
    },
    getPiccard($info) {
      this.formData.piccard = $info.path
      this.formData.piccard_name = $info.name
      this.checkErr('piccard_err')
    },
    getPiccardReserve($info) { // 获取上传图片
      this.formData.piccard_reserve = $info.path
      this.formData.piccard_reserve_name = $info.name
      this.checkErr('piccard_err')
    },
    getCardType($info) { // 获取组件选中的区域类型
      this.formData.card_type = $info.val
      this.formData.card_pic_type = '1'
    },
    onSelectType(action, index) {
      this.formData.card_pic_type = action.val
      this.cardtypeShow = false
      this.$forceUpdate()
    },
    cardtypeShowFn() {
      if (this.isReadonly) { return false }
      this.cardtypeShow = true
    },
    onCancel() { this.cardtypeShow = false },
    onSubmit() { // 认证数据提交
      const data = JSON.parse(JSON.stringify(this.formData))

      if (!data.real_name) {
        return Toast(this.$t('auth.aiAuth.placeholder1'))
      }
      if (!data.id_number) {
        return Toast(this.$t('auth.aiAuth.placeholder3'))
      }
      if (!data.piccard) {
        return Toast(this.$t('auth.nameAuth.formText4'))
      }
      if (data.card_type === '1' && !data.piccard_reserve) {
        return Toast(this.$t('auth.nameAuth.formText4'))
      }

      data.real_name = this.normal_real_name // 名字隐藏例如 **帅 提交数据处理成 刘真帅 这种
      data.id_number = this.normal_id_number // 身份证号同上
      console.log('认证提交数据～～～～～～', data, data.real_name, data.id_number)

      ajaxHttp.$post('/h5/submit_real_info', data).then(res => {
        if (res.code === 1) {
          if (this.isStatusShow) {
            location.reload()
          } else {
            this.$router.replace({ path: '/auth/status', query: { type: '2', lang_id: this.pathInfo.lang_id }})
          }
        } else { Toast(res.message) }
      })
    },
    goAgain($url) {
      this.$router.push({ path: $url, query: { lang_id: this.pathInfo.lang_id }})
    },
    goPath($url, $parame = {}) {
      this.$router.push({ path: $url, query: { ...this.pathInfo }})
    }

  }
}
</script>
